import { AttachServiceRequestsStatusAction } from '../AttachServiceRequestsModal.constants'

export const ATTACH_SERVICE_REQUESTS_STATUS_MODAL_FIELD_NAME_CHANGE_STATUS =
  'changeStatus'

export const QA_NAME_ATTACH_SERVICE_REQUESTS_STATUS_MODAL_CHECKBOX =
  'attachServiceRequestsStatusModalCheckbox'

export const ATTACH_SERVICE_REQUESTS_STATUS_ACTION_CONFIG = {
  [AttachServiceRequestsStatusAction.ChangeStatus]: {
    checkboxLabel: 'Modal.AttachServiceRequestsChangeStatusCheckboxLabelKey',
    notification: 'Modal.AttachServiceRequestsChangeStatusNotificationKey',
  },
  [AttachServiceRequestsStatusAction.Restore]: {
    checkboxLabel: 'Modal.AttachServiceRequestsRestoreCheckboxLabelKey',
    notification: 'Modal.AttachServiceRequestsRestoreNotificationKey',
  },
}
